// Anchor Section Block – frontend viewScript
// Twirling Umbrellas Ltd.

import './anchor-section.scss';

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '[data-anchor-section]' )
		.forEach( initAnchorSection );
} );

/**
 * Initialise one Anchor Section instance.
 *
 * @param {HTMLElement} wrapper
 */
function initAnchorSection( wrapper ) {
	const nav   = wrapper.querySelector( '.anchor-section-nav' );
	const links = nav ? [ ...nav.querySelectorAll( '.anchor-section-link' ) ] : [];

	if ( ! links.length ) return;

	// ------------------------------------------------------------------
	// Mobile collapse toggle.
	// ------------------------------------------------------------------

	const toggle = wrapper.querySelector( '.anchor-section-toggle' );

	if ( toggle ) {
		toggle.addEventListener( 'click', () => {
			const isOpen = wrapper.classList.toggle( 'is-open' );
			toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		} );
	}

	// ------------------------------------------------------------------
	// Smooth scroll. On mobile, also close the dropdown after clicking.
	// ------------------------------------------------------------------

	links.forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			const href = link.getAttribute( 'href' );
			if ( ! href?.startsWith( '#' ) ) return;

			const target = document.getElementById( href.slice( 1 ) );
			if ( ! target ) return;

			e.preventDefault();
			target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
			history.replaceState( null, '', href );

			// Close mobile dropdown after navigation.
			if ( toggle ) {
				wrapper.classList.remove( 'is-open' );
				toggle.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	} );

	// ------------------------------------------------------------------
	// Active state via IntersectionObserver.
	// ------------------------------------------------------------------

	const sections = links
		.map( ( l ) => document.getElementById( l.getAttribute( 'href' ).slice( 1 ) ) )
		.filter( Boolean );

	if ( ! sections.length ) return;

	const setActive = ( id ) => {
		const activeLink = links.find( ( l ) => l.getAttribute( 'href' ) === `#${ id }` );

		links.forEach( ( link ) => {
			const active = link === activeLink;
			link.classList.toggle( 'is-active', active );
			link.setAttribute( 'aria-current', active ? 'true' : 'false' );
		} );

		// Update mobile toggle label to show the current section name.
		if ( toggle && activeLink ) {
			const label = toggle.querySelector( '.anchor-section-toggle__label' );
			if ( label ) label.textContent = activeLink.textContent.trim();
		}
	};

	setActive( sections[ 0 ].id );

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) setActive( entry.target.id );
			} );
		},
		{ rootMargin: '-15% 0px -70% 0px', threshold: 0 }
	);

	sections.forEach( ( s ) => observer.observe( s ) );
}